import React from 'react'
import { useState,useEffect } from 'react'
import "./ScopeOfWorkMain.css"
import DesktopNavbar from '../../components/Navbar/Desktop/DesktopNavbar'
import ScopeOfWorkTopButtons from '../../components/ScopeOfWorkTopButtons/ScopeOfWorkTopButtons'
import MobileNavbar from '../../components/Navbar/Mobile/MobileNavbar'
import MobileMiniDrawer from '../../components/MiniDrawer/MobileMiniDrawer/MobileMiniDrawer'
import DesktopMiniDrawer from '../../components/MiniDrawer/DesktopMiniDrawer/DesktopMiniDrawer'

function ScopeOfWorkMain() {
    const [isMiniDrawerVisible, setIsMiniDrawerVisible] = useState(false);
    
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []); 
    
    const toggleMiniDrawer = () => {
      setIsMiniDrawerVisible(!isMiniDrawerVisible);
    };

  return (
    <>

<div style={{ backgroundColor: "#F2F4F6" }} className='orderSummary-mobile-hide'>
        <div style={{ padding: "0px", margin: "0px" }} className='container-fluid navbar-mobile-hide'>
          <DesktopNavbar />
        </div>
        <div className='row p-0'>
          <div className='col-2 p-0'>
            <DesktopMiniDrawer />
          </div>
          <div className='col-10 mb-4' style={{marginTop:"90px"}} >
          <ScopeOfWorkTopButtons/>
    <div style={{borderRadius:"8px",backgroundColor:"white" ,boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",paddingBottom:"5px"}} className='container-fluid'>
    <div className='mt-4 py-4'>
      <div className="">
  <div className="px-3">
    <h2 style={{fontSize:"20px"}} className='heading text-start'>Scope Of Work</h2>
    <div  className=' text-start scope-work-content mb-3 text-center flex justify-content-center align-items-center p-2' style={{color:"#6A6A6A",backgroundColor:"#F0F0F0",borderRadius:"7px",padding:"20px"}}>
        <div className='row'>
    <div className='text-start col-lg-1 col-md-1 col-sm-1 '>
            <h4>#</h4>
        </div>
        <div className='col-lg-3 col-md-3 col-sm-12 text-start px-4' >
            <h4>Service</h4>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-12' style={{textAlign:"justify"}}>
            <div className='row'>
<div className='col-lg-5 col-md-5 col-sm-12 px-3'>
<h4>Status</h4>
</div>
<div className='col-lg-7 col-md-7 col-sm-12 px-2'>
<h4>Remark</h4>
</div>
            </div>
        </div>
        </div>
    </div>
    <div className='scope-work-content  mb-3 text-center flex justify-content-center align-items-center' style={{color:"#6A6A6A",borderRadius:"7px",padding:"20px",backgroundColor:"#F6F3FF"}}>
  <div className='row'>
    <div className='col-lg-1 col-md-1 col-sm-1 text-start px-0' style={{color:"#6A6A6A"}}>
            <h4>01</h4>
        </div>
        <div className='col-lg-3 col-md-3 col-sm-12 text-start'>
            <h4>Air Freight</h4>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-12' style={{textAlign:"justify"}}>
            <div className='row'>
<div className='col-lg-5 col-md-5 col-sm-12'>
<h4 style={{color:"#28A745"}}>REQUIRED</h4>
<h4>Accompanied (In Cargo)</h4>
</div>
<div className='col-lg-7 col-md-7 col-sm-12'>
<h4>Lorem Ipsum is simply dummy text of the printing </h4>
</div>
            </div>
        </div>
        </div>
    </div>
    <div className='scope-work-content  mb-3 text-center flex justify-content-center align-items-center' style={{color:"#6A6A6A",borderRadius:"7px",padding:"20px",backgroundColor:"white"}}>
  <div className='row'>
    <div className='col-lg-1 col-md-1 col-sm-1 text-start px-0' style={{color:"#6A6A6A"}}>
            <h4>01</h4>
        </div>
        <div className='col-lg-3 col-md-3 col-sm-12 text-start'>
            <h4>Air Freight</h4>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-12' style={{textAlign:"justify"}}>
            <div className='row'>
<div className='col-lg-5 col-md-5 col-sm-12'>
<h4 style={{color:"#28A745"}}>REQUIRED</h4>
<h4>Accompanied (In Cargo)</h4>
</div>
<div className='col-lg-7 col-md-7 col-sm-12'>
<h4>Lorem Ipsum is simply dummy text of the printing </h4>
</div>
            </div>
        </div>
        </div>
    </div>
    <div className='scope-work-content  mb-3 text-center flex justify-content-center align-items-center' style={{color:"#6A6A6A",borderRadius:"7px",padding:"20px",backgroundColor:"#F6F3FF"}}>
  <div className='row'>
    <div className='col-lg-1 col-md-1 col-sm-1 text-start px-0' style={{color:"#6A6A6A"}}>
            <h4>01</h4>
        </div>
        <div className='col-lg-3 col-md-3 col-sm-12 text-start'>
            <h4>Air Freight</h4>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-12' style={{textAlign:"justify"}}>
            <div className='row'>
<div className='col-lg-5 col-md-5 col-sm-12'>
<h4 style={{color:"#28A745"}}>REQUIRED</h4>
<h4>Accompanied (In Cargo)</h4>
</div>
<div className='col-lg-7 col-md-7 col-sm-12'>
<h4>Lorem Ipsum is simply dummy text of the printing </h4>
</div>
            </div>
        </div>
        </div>
    </div>
      <div className='scope-work-content  mb-3 text-center flex justify-content-center align-items-center' style={{color:"#6A6A6A",borderRadius:"7px",padding:"20px",backgroundColor:"white"}}>
  <div className='row'>
    <div className='col-lg-1 col-md-1 col-sm-1 text-start px-0' style={{color:"#6A6A6A"}}>
            <h4>01</h4>
        </div>
        <div className='col-lg-3 col-md-3 col-sm-12 text-start'>
            <h4>Air Freight</h4>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-12' style={{textAlign:"justify"}}>
            <div className='row'>
<div className='col-lg-5 col-md-5 col-sm-12'>
<h4 style={{color:"#28A745"}}>REQUIRED</h4>
<h4>Accompanied (In Cargo)</h4>
</div>
<div className='col-lg-7 col-md-7 col-sm-12'>
<h4>Lorem Ipsum is simply dummy text of the printing </h4>
</div>
            </div>
        </div>
        </div>
    </div> 
     <div className='scope-work-content  mb-3 text-center flex justify-content-center align-items-center' style={{color:"#6A6A6A",borderRadius:"7px",padding:"20px",backgroundColor:"#F6F3FF"}}>
  <div className='row'>
    <div className='col-lg-1 col-md-1 col-sm-1 text-start px-0' style={{color:"#6A6A6A"}}>
            <h4>01</h4>
        </div>
        <div className='col-lg-3 col-md-3 col-sm-12 text-start'>
            <h4>Air Freight</h4>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-12' style={{textAlign:"justify"}}>
            <div className='row'>
<div className='col-lg-5 col-md-5 col-sm-12'>
<h4 style={{color:"#28A745"}}>REQUIRED</h4>
<h4>Accompanied (In Cargo)</h4>
</div>
<div className='col-lg-7 col-md-7 col-sm-12'>
<h4>Lorem Ipsum is simply dummy text of the printing </h4>
</div>
            </div>
        </div>
        </div>
    </div>
  </div>
</div>

    </div>
    <hr/>
    <div  className='container-fluid'>
<div style={{backgroundColor:"#F6F3FF"}} className='mt-4 p-3 mb-4' >
    <h4 style={{}}>Other <span style={{color:"#5B489D",borderRadius:"7px"}}>Requirement</span></h4>
    <p style={{fontSize:"16px"}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
</div>
    </div>
    </div>
          </div>
        </div>
      </div>

    {/* mobile view  */}
    <div    className="orderSummary-mobile-show mb-4">
        <div style={{ padding: "0px", margin: "0px" ,opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s'}} className='container-fluid'>
          <MobileNavbar onToggle={toggleMiniDrawer} active="ordersummary" />
        </div>
        <div className='row p-0'>
          <div className='col-12 p-0 mobile-view-show' style={{ opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s',marginTop:"81px"}}>
            <ScopeOfWorkTopButtons  />
            <div style={{backgroundColor:"white",height:"100vh"}} className='container-fluid mb-4'>
    <div className='py-1'>
      <div className="">
  <div className="px-1">
    <h4 style={{margin:"0px"}} className='heading text-start mb-3 mt-3'>Scope Of Work</h4>
    <div className='py-1 mt-3 mb-0' style={{backgroundColor:"white",borderRadius:"7px"}}>
    <div className='container-fluid px-0'>
            <div style={{backgroundColor:"#F6F3FF" }} className="row mb-3">
            <div className="col-12 px-0">
    <div   className='col-lg-12 col-md-12 itinerary-main-list-right'>
      <div style={{borderLeft:"none"}} className='row itinerary-main-list-right-content'>
    <div style={{backgroundColor:"#F6F3FF"}} class="container-fluid p-0  text-start">
      <div style={{paddingLeft:"12px",paddingTop:"8px",paddingRight:"8px"}}  class="row  mb-3 me-1">
       <h4  style={{borderBottom:"1px solid #6a6a6a",fontSize:"15px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 0px"}}  class="col-12">1. Air Freight</h4>
     </div>
  <div  class="row">
       <h4  style={{fontSize:"14px", color:"#6a6a6a",fontWeight:"660px",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-3">Status</h4>
       <h4  style={{fontSize:"14px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-1">:</h4>
          <h4 style={{fontSize:"14px",fontWeight:"700", color:"#28A745",padding:"8px 8px 8px 12px"}}  class="col-8">REQUIRED<span style={{paddingLeft:"5px",color:"#6a6a6a",fontSize:"14px",fontWeight:"600px"}}>Accompanied (In Cargo)</span></h4>
     </div>
     <div  class="row">
       <h4  style={{fontSize:"14px",fontWeight:"660px", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-3">Remark</h4>
       <h4  style={{fontSize:"14px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-1">:</h4>
          <h4 style={{fontSize:"14px",fontWeight:"600", color:"#474747",padding:"8px 8px 8px 12px"}}  class="col-8">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h4>
     </div>
</div>

      </div>
    </div>
  </div>
</div>
            </div>
            <div className='container-fluid px-0'>
            <div style={{backgroundColor:"white" }} className="row mb-3">
            <div className="col-12 px-0">
    <div   className='col-lg-12 col-md-12 itinerary-main-list-right'>
      <div style={{borderLeft:"none"}} className='row itinerary-main-list-right-content'>
    <div style={{backgroundColor:"white"}} class="container-fluid p-0  text-start">
      <div style={{paddingLeft:"12px",paddingTop:"8px",paddingRight:"8px"}}  class="row  mb-3 me-1">
       <h4  style={{borderBottom:"1px solid #6a6a6a",fontSize:"15px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 0px"}}  class="col-12">1. Air Freight</h4>
     </div>
  <div  class="row">
       <h4  style={{fontSize:"14px", color:"#6a6a6a",fontWeight:"660px",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-3">Status</h4>
       <h4  style={{fontSize:"14px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-1">:</h4>
          <h4 style={{fontSize:"14px",fontWeight:"700", color:"#28A745",padding:"8px 8px 8px 12px"}}  class="col-8">REQUIRED<span style={{paddingLeft:"5px",color:"#6a6a6a",fontSize:"14px",fontWeight:"600px"}}>Accompanied (In Cargo)</span></h4>
     </div>
     <div  class="row">
       <h4  style={{fontSize:"14px",fontWeight:"660px", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-3">Remark</h4>
       <h4  style={{fontSize:"14px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-1">:</h4>
          <h4 style={{fontSize:"14px",fontWeight:"600", color:"#474747",padding:"8px 8px 8px 12px"}}  class="col-8">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h4>
     </div>
</div>

      </div>
    </div>
  </div>
</div>
            </div>
            <div className='container-fluid px-0'>
            <div style={{backgroundColor:"#F6F3FF" }} className="row mb-3">
            <div className="col-12 px-0">
    <div   className='col-lg-12 col-md-12 itinerary-main-list-right'>
      <div style={{borderLeft:"none"}} className='row itinerary-main-list-right-content'>
    <div style={{backgroundColor:"#F6F3FF"}} class="container-fluid p-0  text-start">
      <div style={{paddingLeft:"12px",paddingTop:"8px",paddingRight:"8px"}}  class="row  mb-3 me-1">
       <h4  style={{borderBottom:"1px solid #6a6a6a",fontSize:"15px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 0px"}}  class="col-12">1. Air Freight</h4>
     </div>
  <div  class="row">
       <h4  style={{fontSize:"14px", color:"#6a6a6a",fontWeight:"660px",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-3">Status</h4>
       <h4  style={{fontSize:"14px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-1">:</h4>
          <h4 style={{fontSize:"14px",fontWeight:"700", color:"#28A745",padding:"8px 8px 8px 12px"}}  class="col-8">REQUIRED<span style={{paddingLeft:"5px",color:"#6a6a6a",fontSize:"14px",fontWeight:"600px"}}>Accompanied (In Cargo)</span></h4>
     </div>
     <div  class="row">
       <h4  style={{fontSize:"14px",fontWeight:"660px", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-3">Remark</h4>
       <h4  style={{fontSize:"14px",fontWeight:"bold", color:"#6a6a6a",margin:"0px",padding:"8px 0px 8px 12px"}}  class="col-1">:</h4>
          <h4 style={{fontSize:"14px",fontWeight:"600", color:"#474747",padding:"8px 8px 8px 12px"}}  class="col-8">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h4>
     </div>
</div>

      </div>
    </div>
  </div>
</div>
            </div>
            </div>
  </div>
</div>

    </div>
    <hr style={{margin:"0px"}}/>
    <div style={{paddingBottom:"20px"}}  className='container-fluid mb-4 '>
<div style={{backgroundColor:"#F6F3FF"}} className='mt-4 p-3 mb-4' >
    <h4 style={{color:"#6a6a6a",fontSize:"14px",fontWeight:"bold"}}>Other <span style={{fontSize:"14px",color:"#5B489D",borderRadius:"7px",fontWeight:"bold"}}>Requirement</span></h4>
    <p style={{fontSize:"14px"}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
</div>
    </div>
    </div>
          </div>
          {isMiniDrawerVisible && (
            <div className='col-12'>
              <MobileMiniDrawer onClose={toggleMiniDrawer} />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default ScopeOfWorkMain